// extracted by mini-css-extract-plugin
export default {"formSwitch":"style_formSwitch__h6Otp"};